import { createClient } from '@supabase/supabase-js';
import { devMockClient } from './devMockClient';

const URL = process.env.REACT_APP_SUPABASE_URL;
const ANON = process.env.REACT_APP_SUPABASE_ANON_KEY;
// Dual gate: NODE_ENV must be development AND flag explicitly true.
// CRA bakes NODE_ENV=production at `npm run build`, so production builds
// can never activate the mock client — even if REACT_APP_DEV_MOCK leaks in.
const DEV_MOCK =
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_DEV_MOCK === 'true';

if (DEV_MOCK) {
  // eslint-disable-next-line no-console
  console.warn('[Supabase] DEV MOCK mode — žiadny real network call. Reset: window.__todueDevMock.reset()');
} else if (!URL || !ANON) {
  // eslint-disable-next-line no-console
  console.warn('[Supabase] Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY');
}

const realClient = (URL && ANON)
  ? createClient(URL, ANON, {
      auth: {
        flowType: 'pkce',
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        storageKey: 'cashdeck-auth',
      },
    })
  : null;

export const supabase = DEV_MOCK ? devMockClient : realClient;

// Helper — friendly Slovak error message from supabase error
export function sbError(err) {
  if (!err) return '';
  const m = err.message || String(err);
  if (m.includes('schema cache') || m.includes('does not exist')) {
    return 'Databázová schéma ešte nie je nastavená. Spusti supabase_schema.sql v Supabase SQL Editori.';
  }
  if (m.includes('JWT') || m.includes('token')) return 'Sedenie vypršalo. Prihlás sa znova.';
  if (m.includes('row-level security') || m.includes('RLS')) return 'Nemáš oprávnenie na túto akciu.';
  if (m.includes('duplicate key')) return 'Tento záznam už existuje.';
  return m;
}
